import React, { useCallback } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import type { PageMode } from '../../../common/constants/page-mode';
import { ModeToggle } from '../../../common/ui/mode-toggle';
import { onPageModeToggled } from '../../../common/utils/events/page-mode-toggled';
import { useAnalytics } from '../../../controllers/analytics';
import { useSearchSessionId } from '../../../controllers/store/bootstrap';
import { usePageMode, useSearchActions } from '../../../controllers/store/search';

export const ModeToggleConnected = (): React.JSX.Element | null => {
	const pageMode = usePageMode();
	const { setPageMode } = useSearchActions();
	const { fireAnalyticsEvent } = useAnalytics();
	const [searchSessionId] = useSearchSessionId();

	const onChange = useCallback(
		(next: PageMode) => {
			if (next === pageMode) {
				return;
			}
			setPageMode(next);
			fireAnalyticsEvent(
				onPageModeToggled({ from: pageMode, to: next, source: 'manual-toggle', searchSessionId }),
			);
		},
		[pageMode, setPageMode, fireAnalyticsEvent, searchSessionId],
	);

	if (!fg('rovo_search_chat_convergence')) {
		return null;
	}

	return <ModeToggle pageMode={pageMode} onChange={onChange} />;
};
